import { clientApp } from './index';

export const getCanonicalFields = () => clientApp.get(`/ui/user/canonical/fields`);
